import { FilterFormFieldsEnum } from "@src/pages/ab-test-explore/enum";
import { Form } from "antd";
import { FormInstance } from "antd/lib/form";
import React from "react";

import { BaseSelectExtraField } from "./base-select-extra-field";
import { useGetOptionExtraField } from "@src/hooks/ab-testing/use-get-option-extra-field";
import { generalStyleFormExtraItem } from "../modal-content";

export const Country: React.FC<{ form: FormInstance }> = ({ form }) => {
  const { isLoading, options } = useGetOptionExtraField({
    dimension: "country_code",
    fieldName: FilterFormFieldsEnum.EXTRA_COUNTRY,
    form,
  });

  return (
    <Form.Item {...generalStyleFormExtraItem} name={FilterFormFieldsEnum.EXTRA_COUNTRY} label="Country">
      <BaseSelectExtraField
        fieldName={FilterFormFieldsEnum.EXTRA_COUNTRY}
        loading={isLoading}
        placeholder="Country"
        options={options}
      />
    </Form.Item>
  );
};
